import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, Palette, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { if (!loading && user) navigate("/admin", { replace: true }); }, [user, loading, navigate]);

  return (
    <div className="min-h-screen bg-confetti grid place-items-center px-5" data-testid="admin-login">
      <div className="paper-noise fixed inset-0 pointer-events-none" />
      <div className="relative brut-card p-10 max-w-md w-full text-center">
        <span className="grid place-items-center w-16 h-16 mx-auto rounded-2xl bg-bubble border-[3px] border-ink shadow-brut mb-5">
          <Palette className="w-8 h-8 text-white" />
        </span>
        <h1 className="font-display font-bold text-3xl">Owner Dashboard</h1>
        <p className="text-ink/60 mt-2 mb-8">Sign in to manage orders, sales, gallery & more.</p>
        <button onClick={login} className="brut-btn bg-sun w-full text-lg" data-testid="google-login-btn">
          <LogIn className="w-5 h-5" /> Sign in with Google
        </button>
        <p className="text-xs text-ink/50 mt-5 flex items-center justify-center gap-1">
          <ShieldCheck className="w-3 h-3" /> The first account to sign in becomes the owner.
        </p>
      </div>
    </div>
  );
}
